(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["umberloom-dream-studio"] && !Shopify.designMode) return;
  try {
    
  function positionStudioInstagram() {
    document.querySelectorAll('.ud-instagram-slot[data-instagram-section]').forEach(slot => {
      const id = slot.dataset.instagramSection;
      const source = Array.from(document.querySelectorAll('#MainContent > .shopify-section')).find(el => el.id.endsWith('__' + id));
      if (source && !slot.contains(source)) slot.appendChild(source);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', positionStudioInstagram);
  else positionStudioInstagram();
  document.addEventListener('shopify:section:load', positionStudioInstagram);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umberloom-member-popup"] && !Shopify.designMode) return;
  try {
    
  function setupUmberloomMemberPopup(){
    const dialog=document.querySelector('[data-um-member-popup]');
    if(!dialog||dialog.dataset.initialized||window.Shopify?.designMode)return;
    dialog.dataset.initialized='true';
    const key='umberloom-member-popup-v1';
    const subscriberKey='umberloom-newsletter-subscribed';
    const week=7*24*60*60*1000;
    function suppressed(){try{return localStorage.getItem(subscriberKey)==='true'||Date.now()-Number(localStorage.getItem(key)||0)<week||sessionStorage.getItem(key)==='seen';}catch{return false;}}
    function remember(){try{localStorage.setItem(key,String(Date.now()));sessionStorage.setItem(key,'seen');}catch{}}
    dialog.querySelectorAll('[data-um-dismiss]').forEach(button=>button.addEventListener('click',()=>{remember();dialog.close();}));
    const success=dialog.querySelector('[data-um-subscribe-success]');
    if(success){try{localStorage.setItem(subscriberKey,'true');}catch{}dialog.showModal();success.focus();return;}
    if(dialog.querySelector('[data-um-subscribe-error]')){dialog.showModal();return;}
    dialog.addEventListener('cancel',remember);
    dialog.addEventListener('click',event=>{const box=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)){remember();dialog.close();}});
    if(suppressed())return;
    let attempts=0;
    function show(){
      if(suppressed())return;
      const busy=document.hidden||document.querySelector('dialog[open],.tingle-enabled,.open-drawer,.open-popup');
      if(busy){if(++attempts<12)setTimeout(show,5000);return;}
      dialog.showModal();
      try{sessionStorage.setItem(key,'seen');}catch{}
    }
    setTimeout(show,15000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupUmberloomMemberPopup);
  else setupUmberloomMemberPopup();

  } catch(e) { console.error(e); }
})();
})();
